/* Auto-generated from powerpoint-schemas.proto */
import { Oart } from './officeart-schemas';
export namespace Ppt {
    export interface IPresentation {
        slides?: ISlide[];
    }
    export interface ISlideMoniker {
        sId?: number;
        cId?: number;
    }
    export interface ISlide {
        id?: string;
        mk?: ISlideMoniker;
        drawingElems?: Oart.IDrawingElement[];
    }
    export interface IDescriptor {
        isCompliant?: boolean;
        licenseType?: string;
    }
    export interface ICritiqueTypeOption {
        id?: string;
        languageId?: string;
        value?: string;
    }
    export interface IAppMetadata {
        languageUxId?: string;
        Descriptor?: IDescriptor;
        overriddenCritiqueTypeOptions?: ICritiqueTypeOption[];
    }
    export enum SlideTileEventType {
        Undefined = 0,
        Delete = 1,
        Add = 2,
        Change = 3,
        Refresh = 4
    }
    export interface ISlideTile {
        docId?: string;
        id?: string;
        content?: IPresentation;
        reqOrd?: number;
        requestTime?: number;
        appMetadata?: IAppMetadata;
        eventType?: SlideTileEventType;
    }
}
